export const host= 'https://tivaadmin.tipic.in' ;
// export const host= 'https://tiva-rewire.tipic.co.in' ;